<template>
  <div class="container my-6 mx-auto px-6">
    <h2 class="text-2xl text-center font-medium mb-2">{{ title }}</h2>
    <p class="text-center mb-6">{{ subTitle }}</p>

    <div class="flex justify-center items-center mb-6 sm:flex-col">
      <a href="/enquiry" class="mx-2 sm:mx-0 sm:my-2 sm:w-full sm:block">
        <button type="button" class="flex items-center btn btn-primary input-tall justify-center w-full">
          <svg width="24" height="24" class="fill-white text-white lg:mr-4">
            <use xlink:href="/img/sprite.svg#ic_send"></use>
          </svg>
          <span class="font-medium">Send Enquiry</span>
        </button>
      </a>
      <a onclick="openTrengoChat()" class="mx-2 sm:mx-0 sm:my-2 sm:w-full sm:block">
        <button type="button" class="flex items-center btn btn-primary input-tall justify-center w-full">
          <svg width="24" height="24" class="fill-white text-white lg:mr-4">
            <use xlink:href="/img/sprite.svg#ic_chat"></use>
          </svg>
          <span class="font-medium">Chat with us</span>
        </button>
      </a>
    </div>

    <div class="flex justify-center items-center sm:flex-col">
      <div class="flex items-center mx-2 sm:mx-0 sm:my-2">
        <svg width="24" height="24" class="fill-black-light-5 text-black-light-5 mr-2">
          <use xlink:href="/img/sprite.svg#ic_beach"></use>
        </svg>
        <span class="text-black-light-5">Expert travel advice</span>
      </div>
      <div class="flex items-center mx-2 sm:mx-0 sm:my-2">
        <svg width="24" height="24" class="fill-black-light-5 text-black-light-5 mr-2">
          <use xlink:href="/img/sprite.svg#ic_dollar"></use>
        </svg>
        <span class="text-black-light-5">Best price guarantee</span>
      </div>
      <div class="flex items-center mx-2 sm:mx-0 sm:my-2">
        <svg width="24" height="24" class="fill-black-light-5 text-black-light-5 mr-2">
          <use xlink:href="/img/sprite.svg#ic_clock"></use>
        </svg>
        <span class="text-black-light-5">24/7 customer support</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnquiryBlock',
  props: {
    title: {
      type: String,
      default: 'Want to book your ultimate adventure?'
    },
    subTitle: {
      type: String,
      default: 'Let our expert travel designers help plan your perfect trip.'
    }
  }
}
</script>
